import { LoadingSize } from './Loading.types';

type LoadingConstsType = {
  [size in LoadingSize]: {
    size: string;
    thickness: string;
  };
};

export const loadingConsts: LoadingConstsType = {
  large: {
    size: '40px',
    thickness: '4px',
  },
  normal: {
    size: '30px',
    thickness: '3px',
  },
  small: {
    size: '20px',
    thickness: '2px',
  },
  xsmall: {
    size: '13px',
    thickness: '2px',
  },
};
